import React, {FC, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {SelectWrapper, InputTextWrapper} from '../../../../../../components/UI/Form/Input'
import {getCampById} from '../../../../services'
import {CampModel} from '../../../../model'
import {useCentral} from '../../../../../../hooks/useCentral'
import {initValues} from '../../../../util/values/camp'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
import {TITLE_FORM_CAMP} from '../../../../util/Constants'
import AditionalForm from '../../../../../../components/UI/Form/aditionalCamp/aditionalCampCentral'
import {useSite, useCompany, useClient} from '../../../../hooks'
const Index: FC = () => {
  const {setValue} = useFormContext()
  const {currentTabItem} = useCentral()
  const {siteList, getSiteList} = useSite()
  const {clientList, getClientList} = useClient()
  const {companyList, getCompanyList} = useCompany()

  const getCampByIdValues = async () => {
    try {
      const response = await getCampById(currentTabItem.idToEdit)
      const data = response.data.data
      type CampModelKeys = keyof CampModel

      for (const fieldName in initValues) {
        if (initValues.hasOwnProperty(fieldName)) {
          if (data.hasOwnProperty(fieldName)) {
            if (data[fieldName as CampModelKeys]) {
              if (fieldName === 'clienteId') {
                getClientList({companiaId: data['companiaId']})
                setValue('clienteId', data['clienteId'])
              } else if (fieldName === 'siteId') {
                getSiteList({clienteId: data['clienteId']})
                setValue('siteId', data['siteId'])
              } else if (fieldName === 'campoadicionalFec1') {
                let valueDep = data[fieldName as CampModelKeys]
                if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                  const fechaLocal = new Date(valueDep)
                  const formattedDate = fechaLocal.toISOString().slice(0, 10)
                  setValue(fieldName, formattedDate)
                }
              } else if (fieldName === 'campoadicionalFec2') {
                let valueDep = data[fieldName as CampModelKeys]
                if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                  const fechaLocal = new Date(valueDep)
                  const formattedDate = fechaLocal.toISOString().slice(0, 10)
                  setValue(fieldName, formattedDate)
                }
              } else {
                setValue(fieldName, data[fieldName as CampModelKeys])
              }
            } else {
              setValue(fieldName, '')
            }
          }
        }
      }
    } catch (error) {
      console.error('Error al obtener campamento:', error)
    }
  }
  useEffect(() => {
    getCompanyList({})
  }, [])
  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getCampByIdValues()
    }
  }, [currentTabItem.idToEdit])
  let isDisabled = currentTabItem.idToEdit ? true : false
  const handleGetClientList = async (val: any) => {
    let value = val ? val.value : ''
    getClientList({companiaId: value})
  }
  const handleGetSiteList = async (val: any) => {
    let value = val ? val.value : ''
    getSiteList({clienteId: value})
  }

  return (
    <ContentForm isEdit={isDisabled} title={TITLE_FORM_CAMP}>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Compañía'
            name='companiaId'
            data={companyList}
            disabled={isDisabled}
            onChangeValue={handleGetClientList}
            required
          />
        </div>

        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Cliente'
            name='clienteId'
            data={clientList}
            disabled={isDisabled}
            onChangeValue={handleGetSiteList}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Site'
            name='siteId'
            data={siteList}
            disabled={isDisabled}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Campamento'
            textPlaceholder='Escribe el nombre'
            name='nombre'
            disabled={isDisabled}
            required
          />
        </div>
      </div>
      <hr className='divider' />
      <AditionalForm />
    </ContentForm>
  )
}

export default Index
